export default __webpack_public_path__ + "80ab1b8524e731eaa1bf1762f16bbc73.png";